// extracted by mini-css-extract-plugin
export default {"inlineAdWrapper":"KT-z","inlineTitle":"LT-z","sponsoredAdsWrapper":"MT-z","marketplaceRecosWrapper":"NT-z"};